module.exports = __webpack_public_path__ + "graphics/upgrade-banner-right.ckh.e3daa8de877060bf4846438a9cf10061.svg";